<template lang="pug">
.doFILLBLANKS
  .cont  {{cont.stem}}
  li(v-for='(v,index) in item.list').main-li
    Select.main-select(v-model='v.department',:disabled='disabled_state')
      Option(v-for='x in arr',:value="x.id" :key="x.id",:disabled="disabled_select(x)")  {{x.departmentName}}
    input.content-text(v-model='v.content',:disabled='disabled_state')
    Icon(type="ios-close-circle",color='#E72020',size='20',@click='fun_delete(index)')
  button.addButton(@click='addDepartment') +  添加
</template>

<script>
export default {
  props: ["cont", "HistoryData", "Boer"],
  data() {
    return {
      Completed: sessionStorage.getItem("Completed") === "true",
      option: "",
      arr: [],
      disabled_state: !this.Boer || sessionStorage.getItem("Completed") === "true",
      id: false,
      item: { list: [{ department: "", content: "" }] }
    };
  },
  methods: {
    disabled_select(value) {
      console.log(value);
      console.log(this.item.list);
      return !!this.item.list.find(item => {
        return item.department === value.id;
      });
    },
    fun_delete(index) {
      if (this.disabled_state) {
        return false;
      }
      if (this.item.list.length === 1) {
        return this.$Message.error("不能再少啦");
      }
      this.item.list.splice(index, 1);
    },
    addDepartment() {
      if (this.disabled_state) {
        return false;
      }
      console.log(this.cont.answer, this.item.list);
      if (!this.item.list || JSON.parse(this.cont.answer).length === this.item.list.length) {
        return this.$Message.error("不能再添加啦");
      }
      this.item.list.push({ department: "", content: "" });
    }
  },
  created() {
    // console.log(JSON.parse(this.cont.metas));
    // console.log(this.$store.state.doCase.ALLhall[+sessionStorage.getItem("doIndex")]);
    /** 当前阶段全部大厅 */
    const hall = this.$store.state.doCase.ALLhall[+sessionStorage.getItem("doIndex")];
    const arr = [];
    for (let index = 0; index < JSON.parse(this.cont.metas).length; index++) {
      const element = JSON.parse(this.cont.metas)[index];
      console.log(element);
      const find = value => {
        if (value.id === element.departId) {
          return value;
        }
      };

      if (hall.find(find)) {
        arr.push(hall.find(find));
      }
    }
    console.log(arr);
    this.arr = arr;
    if (this.HistoryData) {
      this.item.list = JSON.parse(this.HistoryData.questionAnswer);
      this.disabled_state = true;
      this.id = this.HistoryData.id;
    }
  }
};
</script>

<style lang="stylus" scoped>
.doFILLBLANKS
  width 100%
  .cont
    font-size 16px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 1)
    line-height 20px
    margin-bottom 10px
  .main-select
    flex 0.2
    margin-right 20px
  .main-li
    display flex
    margin-bottom 12px
    align-items center
    .content-text
      width 596px
      flex 1
      height 32px
      background rgba(255, 255, 255, 1)
      border-radius 4px
      border 1px solid #dddddd
      outline none
      margin-right 4px
  .addButton
    width 100px
    height 32px
    background rgba(255, 255, 255, 1)
    border-radius 4px
    border 1px solid rgba(58, 118, 210, 1)
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(58, 118, 210, 1)
    line-height 18px
    outline none
    margin-top 22px
</style>
